import * as z from "zod";
import { VisitDetailsSchema } from "@/pages/requests/components";
import { RequestResponse } from "@/services/api";

export type VisitDetailsFormSchemaState = z.infer<typeof VisitDetailsSchema>;

export interface VisitDetailsFormProps {
  data: RequestResponse | null;
  subStep: string;
  onSetIsValidStep: (isValid: boolean) => void;
}

export enum VisitDetailsField {
  Purpose = "Purpose",
  From = "From",
  To = "To",
  DateRange = "DateRange",
  NumbersGeneral = "NumbersGeneral",
  NumberOfPersonnel = "NumberOfPersonnel",
  NumberOfVehicles = "NumberOfVehicles",
  NumberOfCameras = "NumberOfCameras",
  NumberOfVessels = "NumberOfVessels",
}

export enum VisitDetailsDateRangeStatus {
  Valid = "valid",
  InvalidRange = "invalidRange",
  EndBeforeStart = "endBeforeStart",
}

export enum VisitDetailsFieldLabel {
  Purpose = "Purpose of visit",
  From = "From",
  To = "To",
  NumberOfPersonnel = "Number of personnel",
  NumberOfVehicles = "Number of vehicles",
  NumberOfCameras = "Photography Permits",
  NumberOfVessels = "Number of vessels",
}
